import { useLocation } from "react-router-dom";
import { api } from "../../../api";
import { useMaybeFindFirst } from "@gadgetinc/react";
import { LoadScenario } from "../../../externalComponents/LoadScenario";
import LoadingSpinner from "../../../externalComponents/LoadingSpinner";
import { useContext } from "react";
import { CustomerContext } from "../../../providers";
import { FallbackPage } from "../../../externalComponents/FallbackPage";

const EditCampaignPage = () => {
  const location = useLocation();
  const campaignId = location.pathname.split("/").slice(-1)[0];
  const { customer } = useContext(CustomerContext);

  const [result] = useMaybeFindFirst(api.campaign, {
    filter: {
      customerId: { equals: customer.id },
      id: { equals: campaignId },
    },
    select: {
      id: true,
      scenario: {
        id: true,
        type: true,
        name: true,
        campaignId: true,
        campaign: {
          sent: true,
          read: true,
          id: true,
          name: true,
          customer: {
            abandonedCartCampaignId: true,
            backInStockCampaignId: true,
            orderConfirmationCampaignId: true,
            orderTrackingCampaignId: true,
            optinConfirmationCampaignId: true,
          },
        },
      },
    },
  });
  const { data, fetching } = result;

  return fetching ? (
    <LoadingSpinner />
  ) : !data ? (
    <FallbackPage />
  ) : (
    <LoadScenario
      scenario={data.scenario}
      campaignId={data.scenario.campaignId}
    />
  );
};

export default EditCampaignPage;
